<sl-checkbox #checkbox [disabled]="disabled" [checked]="innerValue" [name]="name">
  <ng-content />
</sl-checkbox>
